import React from 'react';

const AvailabilityCellHover = ({rateByDay}) => {
  return (
      <div className="rateGridToolTip">
        <p>{rateByDay.rateCode.name}</p>
        {getRate(rateByDay)}
        <p>{rateByDay.roomsRemaining < 5 ? 'Only ' + rateByDay.roomsRemaining
            + ' rooms left. Book Now!' : ''}</p>
        {getOccupancy(rateByDay)}
      </div>
  )
};

const getRate = (rateByDay) => {
  if (rateByDay.type === 'P') {
    return (
        <table className={'rateGridToolTip'}>
          <tbody>
          <tr>
            <td><strong>1 Adult</strong></td>
            <td>{Number.parseInt(
                rateByDay.singlePP, 10).toLocaleString()} {rateByDay.currency}
            </td>
          </tr>
          <tr>
            <td><strong>2 Adults</strong></td>
            <td>{(Number.parseInt(
                rateByDay.sharingPP, 10)
                * 2).toLocaleString()} {rateByDay.currency}
            </td>
          </tr>
          {getKidsRate(rateByDay, 0)}
          {getKidsRate(rateByDay, 1)}
          {getKidsRate(rateByDay, 2)}
          </tbody>
        </table>
    )
  }
  else {
    return (
        <table>
          <tbody>
          <tr>
            <td><strong>Per Room</strong></td>
            <td>{Number.parseInt(
                rateByDay.roomRate, 10).toLocaleString()} {rateByDay.currency}
            </td>
          </tr>
          {getKidsRate(rateByDay, 0)}
          {getKidsRate(rateByDay, 1)}
          {getKidsRate(rateByDay, 2)}
          </tbody>
        </table>
    )
  }
};

const getKidsRate = (rateByDay, index) => {
  if (rateByDay.children !== undefined && rateByDay.children.length > index) {
    let child = rateByDay.children[index];
    let rate = Number.parseInt(child.rate, 10);
    return (
        <tr>
          <td>
            <strong>
              Kids
            </strong>{' '}
            ({child.from}-{child.to})
          </td>
          {rate !== 0 ? (
                  <td> {Number.parseInt(child.rate, 10)} {rateByDay.currency} </td>)
              : (<td>Free</td>)}
        </tr>
    )
  }
  else {
    return (<tr>
      <td/>
      <td/>
    </tr>);
  }
};

const getOccupancy = (rateByDay) => {
  return (
      <table className={'rateGridToolTip'}>
        <tbody>
        <tr>
          <td><strong>Max Occupancy</strong></td>
          <td>
            {rateByDay.maxPax}
          </td>
        </tr>
        <tr>
          <td><strong>Max Adults</strong></td>
          <td>
            {rateByDay.maxAdults}
          </td>
        </tr>
        <tr>
          <td><strong>Max Kids</strong></td>
          <td>
            {rateByDay.maxKids}
          </td>
        </tr>
        </tbody>
      </table>
  )
};

export default AvailabilityCellHover;


// WEBPACK FOOTER //
// ./src/components/AvailabilityCellHover.js